<template>
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-md-10 mx-auto px-0">
                <div class="card my-3 p-4 shadow-sm opacity">
                    <div v-if="!isConfirmed" class="text-center">
                        <div class="spinner-border text-success" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div v-else>
                        <div class="card-header bg-white p-0 border-0 mb-2 d-flex justify-content-between">
                            <h1 class="title fw-bold">Bevestig rapportd</h1>

                            <router-link to="/" class="text-dark text-decoration-none close-button">×</router-link>
                        </div>

                        <div class="card-body p-0">
                            <div class="text-center" v-if="errors.length == 0">
                                <img class="mb-4" :src="asset('images/approved.png')" alt="Goedgekeurd">

                                <h2 class="title">De melding is succesvol bevestigd!</h2>
                            </div>

                            <div v-else>
                                <p class="alert-danger bg-transparent my-1 text-danger" role="alert"
                                   v-if="errors.id" v-for="(name, index) in errors.id">
                                    <strong v-text="errors.id[index]"></strong>
                                </p>
                                <p class="alert-danger bg-transparent my-1 text-danger" role="alert"
                                   v-if="errors.signature" v-for="(name, index) in errors.signature">
                                    <strong class="text-capitalize" v-text="errors.signature[index]"></strong>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ImageMixin from "../mixins/asset";

export default {
    name: "PublishReport",

    mixins: [ImageMixin],

    data() {
        return {
            isConfirmed: false,
            errors: []
        }
    },

    mounted() {
        axios.patch('/api/reports/publish/' + this.$route.params.id + '/' + this.$route.params.hash +
            '?expires=' + this.$route.query.expires + '&signature=' + this.$route.query.signature).then(() => {
            this.isConfirmed = true;

            window.setTimeout(() => {
                if (this.$root.authUser) {
                    this.$router.push({name: 'settings'});
                } else {
                    this.$router.push({name: 'login'})
                }
            }, 3000)
        }).catch((error) => {
            this.isConfirmed = true;
            this.errors = error.response.data.errors
        });
    },

    methods: {

    },
}
</script>

<style scoped>

</style>
